import { Stack, Typography } from '@mui/material'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import shared from '@/components/Settings/settingsShared.module.scss'
import styles from '@/components/Settings/GeneralSettingsContent.module.scss'

/**
 * @param {{ title: string, introKey?: string, children: import('react').ReactNode }} props
 */
export function GeneralSettingsSection({ title, introKey, children }) {
  const intro = introKey ? getSettingsSectionIntro(introKey) : undefined

  return (
    <Stack component="section" spacing={1.25} className={styles.sectionBlock} aria-label={title}>
      <Typography component="h2" className={`${shared.settingsSectionHeading} ${styles.sectionTitle}`}>
        {title}
      </Typography>
      {intro ? <SettingsSectionIntro lines={intro} /> : null}
      {children}
    </Stack>
  )
}
